export default __webpack_public_path__ + "files/logo_app-47c69949109413fa7357ca506b157701.png";